import { render, staticRenderFns } from "./DesignBaseRadio.vue?vue&type=template&id=080a3fd8&"
import script from "./DesignBaseRadio.vue?vue&type=script&lang=js&"
export * from "./DesignBaseRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports